import chevron from '@/services/chevron';
import type { MetricsResponse } from '@/store/analytics/types';

class AnalyticsApiService {
  private getUrl(path: string): string {
    return `${import.meta.env.VITE_API_STARGATE}/bob/anna/v1${path}`;
  }

  async getMetrics(pageId: string, startDate: string, endDate: string): Promise<MetricsResponse> {
    const params = new URLSearchParams({
      page_id: pageId,
      start_date: startDate,
      end_date: endDate,
    });
    const response = await chevron.http({
      url: `${this.getUrl('/metrics')}?${params.toString()}`,
      method: 'GET',
    });
    return response as MetricsResponse;
  }
}

export const analyticsApiService = new AnalyticsApiService();
